import { Collapse } from '@sgme/ui';
import { AccordionSection } from 'components/common-form/sidePanel/AccordionSection';
import type { QuotedTabsPanelProps } from 'components/secondaryMarket/live/sidePanel/quoted/QuotedTabPanel.connect';
import { FC, useState } from 'react';

import { Greeks } from './greeks/Greeks';
import { QuotedDetails } from './QuotedDetails';

export const QuotedTabsPanel: FC<QuotedTabsPanelProps> = ({
  priceType,
  quoteId,
  priceCurrency,
  greeks,
  greeksPrecision,
  accruedInterest,
  quotationType,
}) => {
  const [isGreeksOpened, toggleGreeksTab] = useState(true);
  const hasGreeks = (greeks ?? []).length > 0;

  return (
    <div className="flex-grow-1 overflow-auto mt-2">
      <div className="mb-4">
        <p style={{ width: 'fit-content' }} className="border-bottom border-primary border-3 pe-2">
          Details
        </p>
        <QuotedDetails
          priceType={priceType}
          quoteId={quoteId}
          currency={priceCurrency}
          accruedInterest={accruedInterest}
          quotationType={quotationType}
        />
      </div>

      <Collapse
        fill="fill"
        icon="end"
        size="sm"
        activeKey={isGreeksOpened ? 'greeks' : undefined}
        onSelect={k => toggleGreeksTab(k === 'greeks')}
      >
        {hasGreeks && (
          <AccordionSection
            section="greeks"
            showSpinners={false}
            disabled={false}
            getTitle={(_, formatMsg) => formatMsg('quoteDetails.Tab.Greeks')}
            e2e="greeks"
          >
            <Greeks data={greeks} greeksPrecision={greeksPrecision} className="bg-lvl1" />
          </AccordionSection>
        )}
      </Collapse>
    </div>
  );
};
